import { ZAlert } from '@zoryn/components/alert'
import { ZBadge } from '@zoryn/components/badge'
import { ZButton } from '@zoryn/components/button'
import { ZCard } from '@zoryn/components/card'
import { ZCascader } from '@zoryn/components/cascader'
import {
  ZCheckbox,
  ZCheckboxButton,
  ZCheckboxGroup,
} from '@zoryn/components/checkbox'
import { ZCol } from '@zoryn/components/col'
import { ZCollapse, ZCollapseItem } from '@zoryn/components/collapse'
import { ZColorPicker } from '@zoryn/components/color-picker'
import {
  ZAside,
  ZContainer,
  ZFooter,
  ZHeader,
  ZMain,
} from '@zoryn/components/container'
import { ZDatePicker } from '@zoryn/components/date-picker'
import { ZDialog } from '@zoryn/components/dialog'
import { ZDivider } from '@zoryn/components/divider'
import {
  ZDropdown,
  ZDropdownItem,
  ZDropdownMenu,
} from '@zoryn/components/dropdown'
import { ZForm, ZFormItem } from '@zoryn/components/form'
import { ZIcon } from '@zoryn/components/icon'
import { ZImage } from '@zoryn/components/image'
import { ZInput } from '@zoryn/components/input'
import { ZInputNumber } from '@zoryn/components/input-number'
import { ZPopconfirm } from '@zoryn/components/popconfirm'
import { ZPopover } from '@zoryn/components/popover'
import { ZRadio, ZRadioButton, ZRadioGroup } from '@zoryn/components/radio'
import { ZRate } from '@zoryn/components/rate'
import { ZRow } from '@zoryn/components/row'
import { ZOption, ZSelect } from '@zoryn/components/select'
import { ZSlider } from '@zoryn/components/slider'
import { ZSpace } from '@zoryn/components/space'
import { ZSwitch } from '@zoryn/components/switch'
import { ZTabPane, ZTabs } from '@zoryn/components/tabs'
import { ZTag } from '@zoryn/components/tag'
import { ZText } from '@zoryn/components/text'
import { ZTimePicker } from '@zoryn/components/time-picker'
import { ZTooltip } from '@zoryn/components/tooltip'
import { ZTransfer } from '@zoryn/components/transfer'
import { ZTree } from '@zoryn/components/tree'
import { ZTreeSelect } from '@zoryn/components/tree-select'
import { ZUpload } from '@zoryn/components/upload'

import type { App, Component, Plugin } from 'vue'

const HOST_COMPONENTS: Array<[string, Component]> = [
  ['ZAlert', ZAlert],
  ['ZBadge', ZBadge],
  ['ZButton', ZButton],
  ['ZCard', ZCard],
  ['ZCascader', ZCascader],
  ['ZCheckbox', ZCheckbox],
  ['ZCheckboxButton', ZCheckboxButton],
  ['ZCheckboxGroup', ZCheckboxGroup],
  ['ZCol', ZCol],
  ['ZCollapse', ZCollapse],
  ['ZCollapseItem', ZCollapseItem],
  ['ZColorPicker', ZColorPicker],
  ['ZContainer', ZContainer],
  ['ZAside', ZAside],
  ['ZHeader', ZHeader],
  ['ZMain', ZMain],
  ['ZFooter', ZFooter],
  ['ZDatePicker', ZDatePicker],
  ['ZDialog', ZDialog],
  ['ZDivider', ZDivider],
  ['ZDropdown', ZDropdown],
  ['ZDropdownItem', ZDropdownItem],
  ['ZDropdownMenu', ZDropdownMenu],
  ['ZForm', ZForm],
  ['ZFormItem', ZFormItem],
  ['ZIcon', ZIcon],
  ['ZImage', ZImage],
  ['ZInput', ZInput],
  ['ZInputNumber', ZInputNumber],
  ['ZPopconfirm', ZPopconfirm],
  ['ZPopover', ZPopover],
  ['ZRadio', ZRadio],
  ['ZRadioButton', ZRadioButton],
  ['ZRadioGroup', ZRadioGroup],
  ['ZRate', ZRate],
  ['ZRow', ZRow],
  ['ZSelect', ZSelect],
  ['ZOption', ZOption],
  ['ZSlider', ZSlider],
  ['ZSpace', ZSpace],
  ['ZSwitch', ZSwitch],
  ['ZTabs', ZTabs],
  ['ZTabPane', ZTabPane],
  ['ZTag', ZTag],
  ['ZText', ZText],
  ['ZTimePicker', ZTimePicker],
  ['ZTooltip', ZTooltip],
  ['ZTransfer', ZTransfer],
  ['ZTree', ZTree],
  ['ZTreeSelect', ZTreeSelect],
  ['ZUpload', ZUpload],
]

const installedApps = new WeakSet<App>()

export function installDesignerHost(app: App, designer?: Plugin) {
  if (installedApps.has(app)) return
  installedApps.add(app)
  for (const [name, component] of HOST_COMPONENTS) {
    if (!app.component(name)) {
      app.component(name, component)
    }
  }
  if (designer && typeof designer.install === 'function') {
    app.use(designer)
  }
}
